// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Throttle$Showside from "./Throttle.bs.js";
import * as WebapiUtils$Showside from "./WebapiUtils.bs.js";
import * as ScrollRestoration$Showside from "./ScrollRestoration.bs.js";
import * as GlobalScrollRestoration$Showside from "./GlobalScrollRestoration.bs.js";
function toString(direction) {
  if (direction) {
    return "Down";
  } else {
    return "Up";
  }
}
var jammed = {
  contents: false
};
function jam(param) {
  jammed.contents = true;
}
function unjam(param) {
  jammed.contents = false;
}
function isJammed(param) {
  return jammed.contents;
}
var Jammer = {
  jammed: jammed,
  jam: jam,
  unjam: unjam,
  isJammed: isJammed
};
function useScrollable(enabledOpt, element, initialDirectionOpt, thresholdOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */0;
  var threshold = thresholdOpt !== undefined ? thresholdOpt : 20;
  var match = Throttle$Showside.use(undefined, undefined, function (param) {
    return initialDirection;
  });
  var setScrollDirection = match[1];
  var lastScrollPosition = React.useRef(0);
  var lastScrollDirection = React.useRef(/* Up */0);
  var onScroll = function (e) {
    if (!(enabled && !ScrollRestoration$Showside.isBlockingOnScrollEvent(undefined) && !jammed.contents)) {
      return;
    }
    var target = e.target;
    var scrollTop = target.scrollTop | 0;
    var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */0 : lastScrollDirection.current : /* Up */0;
    Curry._1(setScrollDirection, function (param) {
      return nextDirection;
    });
    lastScrollPosition.current = scrollTop;
    lastScrollDirection.current = nextDirection;
  };
  var addListener = function (element) {
    element.addEventListener("scroll", onScroll, {
      capture: false,
      passive: true,
      once: false
    });
  };
  var removeListener = function (element) {
    element.removeEventListener("scroll", onScroll, {
      capture: false,
      passive: true
    });
  };
  React.useEffect(function () {
    if (element === undefined) {
      return;
    }
    if (!enabled) {
      return;
    }
    var element$1 = Caml_option.valFromOption(element);
    removeListener(element$1);
    addListener(element$1);
    return function (param) {
      removeListener(element$1);
    };
  }, [element]);
  return [match[0], setScrollDirection];
}
function useWindow(enabledOpt, onScroll, initialDirectionOpt, thresholdOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */0;
  var threshold = thresholdOpt !== undefined ? thresholdOpt : 20;
  var match = Throttle$Showside.use(undefined, undefined, function (param) {
    return initialDirection;
  });
  var setScrollDirection = match[1];
  var lastScrollPosition = React.useRef(0);
  var lastScrollDirection = React.useRef(/* Up */0);
  var onScroll$1 = function (e) {
    if (!(!GlobalScrollRestoration$Showside.isBlockingOnScrollEvent(undefined) && !jammed.contents)) {
      return;
    }
    var scrollTop = Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined) | 0;
    var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */0 : lastScrollDirection.current : /* Up */0;
    Curry._1(setScrollDirection, function (param) {
      return nextDirection;
    });
    lastScrollPosition.current = scrollTop;
    lastScrollDirection.current = nextDirection;
    Belt_Option.forEach(onScroll, function (cb) {
      Curry._2(cb, nextDirection, scrollTop);
    });
  };
  React.useEffect(function () {
    if (enabled) {
      window.addEventListener("scroll", onScroll$1, {
        capture: false,
        passive: true,
        once: false
      });
    }
    return function (param) {
      window.removeEventListener("scroll", onScroll$1, {
        capture: false,
        passive: true
      });
    };
  }, [enabled]);
  return [match[0], setScrollDirection];
}
export { toString, Jammer, useScrollable, useWindow };
/* react Not a pure module */